<template>
  <div class="l-thanks">
    <h1>Thank you</h1>
    <p>This wedding was truly a collaboration between us and the many vendors, friends and family that put it together. We want to give our utmost thanks to all those who helped make this day so special.</p>

    <h2>Our vendors</h2>

    <p>Wedding design and planning by <a href="http://www.revisionistevents.com/" target="_blank">Revisionist Events</a></p>

    <p>Our venue was <a href="http://www.beckendorfffarms.com/" target="_blank">Beckendorff Farms</a></p>

    <p>Furniture and rentals from <a href="http://theeventsco.com/" target="_blank">The Events Company</a></p>

    <p>Catering by <a href="http://cafenataliecatering.com/" target="_blank">Cafe Natalie</a></p>

    <p>Flowers by <a href="https://www.flowervibes.com/" target="_blank">Flower Vibes</a></p>

    <p>Desserts by <a href="https://buttercuphouston.com/" target="_blank">Buttercup Bakery</a></p>

    <p>Photography by <a href="http://www.geodun.com/" target="_blank">Geoff Duncan</a></p>

    <p>DJ services by <a href="https://www.theknot.com/marketplace/goldline-entertainment-houston-tx-1068566" target="_blank">Goldline Entertainment</a></p>

    <p>Live string music by by <a href="http://thirdfloorstrings.com/wordpress_5/" target="_blank">Third Floor Strings</a></p>
  </div>
</template>

<script>
export default {
  name: 'thanks'
}
</script>

<style lang="scss">
.l-thanks {
  max-width: 470px;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Thanks.vue